"use client"

import { useRef } from "react"
import { X } from "lucide-react"
import styles from "./CustomPopup.module.css"



export default function CustomPopup({ title, message, onClose, buttons}) {
  const popupRef = useRef(null)


  return (
    <div className={styles.overlay}>
      <div className={styles.popup} ref={popupRef}>
        <div className={styles.header}>
          <h2 className={styles.title}>{title}</h2>
          <button className={styles.closeButton} onClick={onClose} aria-label="Close">
            <X size={18} />
          </button>
        </div>
        <div className={styles.content}>
          <p className={styles.message}>{message}</p>
        </div>
        {buttons.length > 0 && (
          <div className={styles.footer}>
            {buttons.map((button, index) => (
              <button
                key={index}
                className={`${styles.button} ${button.variant ? styles[button.variant] : styles.secondary}`}
                onClick={button.onClick}
              >
                {button.text}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}

